import { css } from '@emotion/react';

import { useTranslation } from 'react-i18next';

import Button from 'components/field/Button';

import useAlert from 'hooks/useAlert';
import useLocale from 'hooks/useLocale';

import AppLogger from 'utils/AppLogger';

import { faDownload } from '@fortawesome/pro-solid-svg-icons';

const DownloadImportFileButton = ({ value, data }) => {
	const { t } = useTranslation();
	const { showError } = useAlert();
	const { getLocaleDateWithTime } = useLocale();

	return (
		value && (
			<Button
				label={!value ? 'expired' : 'download'}
				variant={!value ? 'borderless' : 'blueBorderless'}
				disabled={!value}
				icon={faDownload}
				fullWidth
				css={css`
					margin: auto;
					gap: 1rem;
					> .typography,
					> .icon {
						font-size: var(--paragraph3-font-size) !important;
					}

					:hover {
						background-color: var(--table-selected-color) !important;
					}
				`}
				onClick={() => {
					fetch(value)
						.then((resp) => resp.blob())
						.then((blob) => {
							const url = window.URL.createObjectURL(blob);
							const a = document.createElement('a');
							a.style.display = 'none';
							a.href = url;
							a.download = `${t(data.type)}_${t('import')}_${getLocaleDateWithTime(
								data.completedAt
							)}.xlsx`
								.split(' ')
								.join('_');
							document.body.appendChild(a);
							a.click();
							window.URL.revokeObjectURL(url);
							document.body.removeChild(a);
						})
						.catch((error) => {
							AppLogger.error(error);
							showError();
						});
				}}
			/>
		)
	);
};

export default DownloadImportFileButton;
